export const EXECUTE_METHOD = 'EXECUTE_METHOD';
export function executeMethod(method) {
    return {
        payload: formatMethod(method),
        type: EXECUTE_METHOD,
    };
}
export const EXECUTE_METHODS = 'EXECUTE_METHODS';
export function executeMethods(methods) {
    return {
        payload: methods.map(formatMethod),
        type: EXECUTE_METHODS,
    };
}
export const EXECUTE_METHODS_THEN_DISPATCH_ACTION = 'EXECUTE_METHODS_THEN_DISPATCH_ACTION';
export function executeMethodsThenDispatchAction(methods, templateId, action) {
    return {
        type: EXECUTE_METHODS_THEN_DISPATCH_ACTION,
        payload: {
            type: EXECUTE_METHODS_THEN_DISPATCH_ACTION,
            methods,
            templateId,
            action,
        },
    };
}
function formatMethod(method) {
    return {
        type: method.interface,
        payload: method,
    };
}
